/**
 * License Request.
 *
 *
 * @beta
 */
export const LICENSE_REQUEST = 'license-request'
